<template>
  <div class="list-block"  v-loading.fullscreen.lock="loading">
    <top-part :rightPart="true"></top-part>
    <div class="ctn_top" v-if="questionList&&questionList.length">
    <!-- <div v-infinite-scroll="loadMore" infinite-scroll-distance=50> -->
      <div
        class="card-box"
        v-for="question in questionList"
        :key="question.id"
        @click="handleClickQuestionItem(question)"
      >
        <div class="card-title">
          <span v-if="question.answerId === '-1'" class="question-status-noAnswered">未答</span>
          <span v-else class="question-status-answered">已答</span>
          <span>{{question.question_name}}</span>
          <!-- <span>{{question.name}}</span> -->
        </div>
        <div class="card-footer">
          <span class="content-date" v-if="question.start_time && question.end_time">收集时间:{{question.start_time}}-{{question.end_time}}</span>
          <span class="content-date" v-else-if="!question.start_time && question.end_time">收集时间:{{question.create_time}}-{{question.end_time}}</span>
          <span class="content-date" v-else-if="question.start_time && !question.end_time">开始时间:{{question.start_time}}</span>
          <span class="content-date" v-else-if="question.create_time">创建时间:{{question.create_time}}</span>
          <i class="cubeic-arrow"></i>
        </div>
      </div>
    </div>
    <!-- 没数据时 -->
    <div class="blank" v-if="(!questionList||!questionList.length)&&!loading">
      <img src="@/images/404-02.png" alt>
    </div>
  </div>
</template>

<script>
  import axiosConter from "../../axios/centralControl";
  import moment from "moment";
  import topPart from "../../components/topPart";
  export default {
    data() {
      return {
        questionList: [],
        currentPage: 1,
        pageSize: 100,
        loading:true,
      };
    },
    components: {
      topPart
    },
    mounted() {
      this.loadQuestionData();
    },
    methods: {
      loadMore() {
        this.currentPage = this.currentPage+1;
        this.loadQuestionData();
      },
      loadQuestionData() {
        // const params = {
        //   offSet: this.currentPage - 1, //当前第几页数据
        //   pageSize: this.pageSize //每页显示
        // };
        axiosConter.centralControl(
          "loadQuestionData",
          data => {
            this.loading=false;
            if (data.code == 200) {
              this.questionList = data.data;
              this.questionList = this.questionList.map((item) => {
                return{
                  ...item,
                  start_time: item.start_time ? moment(item.start_time).format("YYYY-MM-DD HH:mm:ss") : item.start_time,
                  end_time: item.end_time ? moment(item.end_time).format("YYYY-MM-DD HH:mm:ss") : item.end_time,
                  create_time: item.create_time ? moment(item.create_time).format("YYYY-MM-DD HH:mm:ss"): item.create_time
                }
              });
              const questionList = this.questionList;
              // this.questionList = data.data.list;
            } else {
              this.$message.error(data.message);
            }
          },
          {}
        );
      },
      handleClickQuestionItem(questionItem) {
        localStorage.setItem('currentQuestionId', questionItem.question_id);
        // localStorage.setItem('currentQuestionItem', JSON.stringify(questionItem));
        this.$router.push('/replyQuestion')
      }
    }
  }
</script>

<style lang="stylus" type="stylesheet/stylus">
.list-block{
  overflow:scroll;
  height:calc(100vh);

  .card-box {
    background: rgba(255, 255, 255, 1);
    padding: 0.3rem 0.42rem 0 0.42rem;
    margin-bottom: 0.4rem;

    .card-title {
      height: auto;
      width: 100%;
      display: inline-block;
      align-items: center;
      font-size: 18px;
      font-weight: 500;
      color: rgba(53, 53, 53, 1);
      border-bottom: 1px solid #e5e5e5;
      padding: 10px 0;
      line-height : 20px;

      span {
        font-weight: 600;
        font-size: 16px;
        margin-left:6px;
      }
      .question-status-noAnswered {
        background-color : #ff0b0b;
        color : #fff;
        text-align : center;
        font-weight: normal;
        padding : 0 4px;
      }
      .question-status-answered {
        background-color : #2CC7C5;
        color : #fff;
        text-align : center;
        font-weight: normal;
        padding : 0 4px;
      }
    }

    .card-footer {
      height: 40px;
      line-height: 40px;
      color: rgba(172, 172, 183, 1);
      font-size: 12px;

      .content-date {
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        color: rgba(172, 172, 183, 1);
      }

      i {
        display:inline-block;
        margin-left:6px;
        font-size: 16px;
        float: right;
        color: rgba(206, 206, 206, 0.6);
      }
    }
  }
}
.card-box {
    background: rgba(255, 255, 255, 1);
    padding: 0.3rem 0.42rem 0 0.42rem;
    margin-bottom: 0.4rem;

    .card-title {
      height: 40px;
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: 500;
      color: rgba(53, 53, 53, 1);
      border-bottom: 1px solid #e5e5e5;

      span {
        font-weight: 600;
        font-size: 16px;
        margin-left:6px;
      }
    }

    .card-footer {
      height: 40px;
      line-height: 40px;
      color: rgba(172, 172, 183, 1);
      font-size: 12px;

      .content-date {
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        color: rgba(172, 172, 183, 1);
      }

      i {
        display:inline-block;
        margin-left:6px;
        font-size: 16px;
        float: right;
        color: rgba(206, 206, 206, 0.6);
      }
    }
}
</style>